import React from 'react';

/**
 * Renders HTML content inside a sandboxed iframe.
 *
 * Security model:
 * - `srcDoc` inlines the fetched HTML so we never expose user HTML to a real origin.
 * - `sandbox="allow-scripts allow-popups"` — scripts execute (agent-generated HTML is
 *   typically interactive), popups can open links, but we deliberately omit
 *   `allow-same-origin` so the iframe runs in an opaque origin with no access to the
 *   parent app's cookies, localStorage, DOM, or ancestor navigation.
 * - This matches the artifact preview pattern used by production AI chat UIs
 *   (Claude artifacts, ChatGPT Canvas, v0.dev).
 */
const HtmlContent = ({ content, filename, isDarkMode }) => (
  <iframe
    title={filename || 'HTML preview'}
    srcDoc={content}
    sandbox="allow-scripts allow-popups"
    className={`file-viewer-html-iframe ${isDarkMode ? 'dark' : 'light'}`}
    loading="eager"
  />
);

export default HtmlContent;
